import { extractPatientFields } from "core/model/patients";
import { Auction } from "core/types";
import { useEffect, useMemo, useState } from "react";

export function useExtractedPatientFields(auction: Auction) {
  const extractedMutable = useMemo(
    () => extractPatientFields(auction),
    [auction],
  );
  const [extracted, setExtracted] = useState(extractedMutable);
  useEffect(() => {
    const changesExist =
      JSON.stringify(extractedMutable) !== JSON.stringify(extracted);
    if (changesExist) setExtracted(extractedMutable);
  }, [extractedMutable, extracted]);
  return extracted;
}
